"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Token {
    constructor(id = '', name = '', entryPointID = '', handlerID = -1, address = '', handlerAddress = '', isDisabled = false, isToken = false, isComingSoon = false, pairTokens = [], replaceString = '{}', image = '') {
        this.id = id;
        this.name = name;
        this.entryPointID = entryPointID;
        this.handlerID = handlerID;
        this.address = address;
        this.sendAddress = handlerAddress;
        this.handlerAddress = handlerAddress;
        this.isDisabled = isDisabled;
        this.isToken = isToken;
        this.isComingSoon = isComingSoon;
        this.pairTokens = pairTokens;
        this.replaceString = replaceString;
        this.image = image;
    }
}
exports.default = Token;
;
//# sourceMappingURL=Token.js.map